import { render, staticRenderFns } from "./CalendarioEscala.vue?vue&type=template&id=2bc55e18&scoped=true"
import script from "./CalendarioEscala.vue?vue&type=script&lang=js"
export * from "./CalendarioEscala.vue?vue&type=script&lang=js"
import style0 from "./CalendarioEscala.vue?vue&type=style&index=0&id=2bc55e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc55e18",
  null
  
)

export default component.exports